import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
`;

export const LeadCreatorSection = styled.div`
  background: #dbeafe;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CreatorName = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #1e40af;
`;

export const CreatorAddress = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #3b82f6;
`;

export const SearchWrapper = styled.div`
  position: relative;
`;

export const UsersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 350px;
  overflow-y: auto;
  padding: 4px;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
`;

export const UserItem = styled.div`
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border: ${({ $selected }) => ($selected ? '2px solid #2D6CDF' : '2px solid #e2e8f0')};
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #cbd5e1;
    border-top: ${({ $selected }) => ($selected ? '2px solid #2D6CDF' : '2px solid #cbd5e1')};
    background: #f8fafc;
  }
`;

export const UserLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #286dd6 0%, #214b89 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const UserName = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  color: #212529;
`;

export const UserRole = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #6c757d;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 44px;
  background: #ffffff;
  border: 1px solid #cad5e2;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    border-color: #94a3b8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SubmitButton = styled.button`
  flex: 1;
  height: 44px;
  background: linear-gradient(90deg, #296bcd 0%, #173a70 100%);
  border: none;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(90deg, #1e5bb8 0%, #0f2a54 100%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EmptyMessage = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
`;

export const LoadingMessage = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
`;

export const ErrorMessage = styled.div`
  padding: 12px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  color: #dc2626;
  font-size: 14px;
  line-height: 20px;
`;
